<template>
  <div class="level-list">
    <div class="level-list-item"
         v-for="item in list"
         :key="item.fresh_customer_level_id">
      <label>{{ item.name }}</label>
      <div><Input type="number"
               :placeholder="$t('pages_products_customer_levels_794', item.name)"
               :value="item.huiyuanjia"
               @on-change="changeHuiyuanjia(item, $event)" />
               <Input type="number"
               :placeholder="$t('pages_products_customer_levels_795', item.name)"
               :value="item.wechat_huiyuanjia"
               @on-change="changeWechatHuiyuanjia(item, $event)" /></div>
    </div>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapState, mapActions } from 'vuex';

export default {
  name: 'fresh_customer_levels',
  props: ['value'],
  data () {
    return {
      values: [],
      list: []
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        this.values = val || [];
        this.getList();
      }
    }
  },
  computed: {
    ...mapState('customer_level', ['customer_levels']),
  },
  async created () {
    await this.index({ per: 65535 })
    this.getList()
  },
  methods: {
    ...mapActions('customer_level', ['index']),
    getList () {
      const { values } = this;
      console.log('values', values)
      let valueMap = {};
      if (Array.isArray(values) && values.length > 0) {
        valueMap = values.reduce((map, { fresh_customer_level_id, huiyuanjia = 0, wechat_huiyuanjia = 0, id = null }) => {
          map[fresh_customer_level_id] = { huiyuanjia, wechat_huiyuanjia, fresh_customer_level_id, id };
          return map;
        }, {});
      }
      console.log('valueMap', valueMap);
      if (!this.customer_levels) return [];
      console.log('this.customer_levels', this.customer_levels)
      let result = JSON.parse(JSON.stringify(this.customer_levels));
      result = result.map((item, index) => {
        if (valueMap[item.id]) {
          item.huiyuanjia = valueMap[item.id].huiyuanjia || null;
          item.wechat_huiyuanjia = valueMap[item.id].wechat_huiyuanjia || null;
          item.fresh_customer_level_id = valueMap[item.id].fresh_customer_level_id || item.id;
          item.id = valueMap[item.id].id || 'j' + index;
        } else {
          item.huiyuanjia = null;
          item.wechat_huiyuanjia = null;
          item.fresh_customer_level_id = item.id;
          item.id = 'j' + index;
        }
        return item;
      });
      console.log('result', result);
      this.list = result;
    },
    getValue () {
      console.log(this.values);
      return this.values.map(item => {
        const result = {
          fresh_customer_level_id: item.fresh_customer_level_id,
          huiyuanjia: item.huiyuanjia,
          wechat_huiyuanjia: item.wechat_huiyuanjia,
          id: item.id
        };
        return result;
      })
    },
    changeHuiyuanjia (data, e) {
      const { id } = data;
      const price = +e.target.value;
      let vals = this.values.slice();
      if (vals.length === 0) {
        vals = this.list;
      }
      const item = vals.find(i => i.id === id);
      if (item) {
        item.huiyuanjia = price;
      } else {
        vals.push(data);
      }
      this.values = vals;
      const values = this.getValue()
      this.$emit('input', values)
    },
    changeWechatHuiyuanjia (data, e) {
      const { id } = data;
      const price = +e.target.value;
      let vals = this.values.slice();
      if (vals.length === 0) {
        vals = this.list;
      }
      const item = vals.find(i => i.id === id);
      if (item) {
        item.wechat_huiyuanjia = price;
      } else {
        vals.push(data);
      }
      this.values = vals;
      const values = this.getValue()
      this.$emit('input', values)
    },
  },
}
</script>

<style lang="scss" scoped>
.level-list {
  display: flex;
  align-items: stretch;
  flex-flow: row wrap;
  width: 100%;
  background: #f5f5f5;
  border-radius: 5px;
  padding: 12px 20px;
  &-item {
    margin-bottom: 8px;
    width: 50%;
    flex: 0 0 auto;
    display: flex;
    label {
      flex: 0 0 auto;
      &:after {
        content: ": ";
        margin-right: 8px;
      }
      &:before {
        content: "";
        margin-left: 8px;
      }
    }
    &-content{
      &:after {
        content: " ";
        margin-right: 8px;
      }
    }
    > div {
      flex: auto;
    }
  }
}
</style>
